import * as React from 'react'
import * as moment from 'moment'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { agentService, utilService } from '../../../../core/services'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { Button, Panel, PanelTitle, Select, CheckBox, Toggle } from '../../../atoms'
import { SingleDatePicker } from 'react-dates'
import DayPickerCustomStyle from 'static/dayPickerCustomStyle'
import SidebarLayout from 'components/pages/_layouts/sidebarLayout'
import * as interfaces from '../../../../static/interfaces'
import * as constants from 'static/constants'

declare var window: interfaces.IWindow

interface IProps {
  guides: any
  selectable_months?: any
  selectable_users?: any
  user: IJsonResponse
}

const SpreadSheet: React.FC<IProps> = props => {
  const { data: userData } = utilService.getDataFromJson(props.user)
  const monthSelectOptions = [...Array(12)].map((v, i) => {
    const month = moment()
      .add(-i, 'months')
      .format('YYYY-MM')
    return { label: month, value: month }
  })
  const [selectedGuides, setSelectedGuides] = React.useState(props.guides)
  const [selectedMonth, setSelectedMonth] = React.useState(monthSelectOptions[0].value)
  const [requested, setRequested] = React.useState(false)
  const [share, setShare] = React.useState(false)
  const [focused, setFocused] = React.useState(false)
  const [issueDate, setIssueDate] = React.useState(moment())

  const updateSelectedGuides = React.useCallback(
    (e: { target: { checked: any; value: any } }) => {
      const guides = selectedGuides
      if (e.target.checked) {
        setSelectedGuides(selectedGuides.concat([e.target.value]))
      } else {
        setSelectedGuides(selectedGuides.filter(guide => guide !== e.target.value))
      }
    },
    [selectedGuides]
  )

  const updateCheckAll = e => {
    if (e.target.checked) {
      setSelectedGuides(props.guides)
    } else {
      setSelectedGuides([])
    }
  }

  const download = React.useCallback(async () => {
    if (
      !share ||
      window.confirm('ガイド共有がonになっています。ガイドに通知書を共有してよろしいですか？')
    ) {
      const { flush } = await agentService.downloadSpreadSheetPayments(
        selectedGuides,
        selectedMonth,
        share,
        issueDate.format('YYYY-MM-DD')
      )
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      setRequested(true)
    }
  }, [selectedGuides, selectedMonth, share, issueDate])

  return (
    <SidebarLayout user={userData}>
      <Panel
        title={
          <TitleWrapper>
            <PanelTitle title={I18n.t('payments.spreadsheet.download')} />
            {!requested && (
              <div className="download">
                <Button handleClick={() => download()} primary={true}>
                  {I18n.t('generic.download')}
                </Button>
              </div>
            )}
          </TitleWrapper>
        }
      >
        <Wrapper>
          {requested ? (
            <div className="requested">{I18n.t('payments.spreadsheet.requested')}</div>
          ) : (
            <>
              <div className="setting">
                <div className="monthLabel">{I18n.t('payments.spreadsheet.month')}</div>
                <Select
                  name="month"
                  options={monthSelectOptions}
                  defaultValue={monthSelectOptions[0].value}
                  onChangeHandler={e => setSelectedMonth(e.target.value)}
                />
                <div className="issueDateLabel">{I18n.t('payments.spreadsheet.issue_date')}</div>
                <DayPickerCustomStyle />
                <SingleDatePicker
                  date={issueDate}
                  onDateChange={date => setIssueDate(date)}
                  focused={focused}
                  onFocusChange={({ _focused }) => setFocused(_focused)}
                  numberOfMonths={1}
                  displayFormat="YYYY-MM-DD"
                  isOutsideRange={() => false}
                />
                <div className="checkAll">
                  <CheckBox
                    name="check_all"
                    checked={selectedGuides.length === props.guides.length}
                    label={I18n.t('generic.select_all')}
                    showLabelInline={true}
                    onChangeHandler={updateCheckAll}
                  />
                </div>
                <div className="share">
                  <Toggle
                    name="share"
                    checked={share}
                    label={I18n.t('payments.spreadsheet.share_with_guide')}
                    onChangeHandler={e => setShare(e.target.checked)}
                  />
                </div>
              </div>
              <div className="guideList">
                {props.guides.map((guide, index) => (
                  <label key={index}>
                    <input
                      type="checkbox"
                      id={`guide-${index}`}
                      name="guides"
                      value={guide}
                      onChange={updateSelectedGuides}
                      checked={
                        selectedGuides.find(selectedGuide => selectedGuide === guide) ? true : false
                      }
                    />
                    {guide}
                  </label>
                ))}
              </div>
            </>
          )}
        </Wrapper>
      </Panel>
    </SidebarLayout>
  )
}

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  .download {
    margin-left: auto;
  }
`
const Wrapper = styled.div`
  .requested {
    white-space: pre-wrap;
    font-size: 14px;
  }
  .setting {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .monthLabel,
    .issueDateLabel {
      font-weight: bold;
      margin-right: 10px;
    }
    .issueDateLabel {
      margin-left: 10px;
    }
    .checkAll {
      margin-left: 14px;
    }
    .share {
      margin-left: auto;
      .Toggle {
        div {
          justify-content: flex-end;
        }
      }
    }
    .DateInput_input {
      padding: 7px 12px;
      font-weight: normal;
      font-size: 16px;
    }
  }
  .guideList {
    display: flex;
    flex-wrap: wrap;
    label {
      width: 25%;
      margin-left: 0px;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 4px;

      input[type='checkbox'] {
        transform: scale(1.2);
        accent-color: ${constants.COLORS.primary};
        appearance: auto;
        margin-right: 6px;
      }
    }
  }
`

export default SpreadSheet
